import { useEffect } from "react";
import ContactForm from "../components/ContactForm";
import { useT } from "../i18n";
import { sectionHeading, sectionSubheading } from "../lib/ui";

export default function ContactPage() {
  const translate = useT();

  useEffect(() => {
    document.title = translate("contactMetaTitle");
  }, [translate]);

  return (
    <section className="py-16 sm:py-24" aria-labelledby="contact-page-heading">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <h1 id="contact-page-heading" className={sectionHeading}>
            {translate("contactPageTitle")}
          </h1>
          <p className={`${sectionSubheading} mx-auto`}>{translate("contactPageSubtitle")}</p>
        </div>

        <div className="mx-auto mt-10 max-w-xl">
          <ContactForm source="contact-page" />
        </div>
      </div>
    </section>
  );
}
